import { defineStore } from 'pinia';

export const useSizeStore = defineStore('size', {
  state: () => ({
    size: 'normal',
  }),
  actions: {
    setSize(newSize: string) {
      this.size = newSize;
    },
  },
  persist: {
    storage: localStorage,
  },
});
